export enum ReceiverRole {
  ROLE_PLATFORM = 'platform',
  ROLE_GATEWAY = 'gateway',
  ROLE_SELLER = 'seller',
  ROLE_PARTNER = 'partner',
  ROLE_AFFILIATE = 'affiliate',
}
